/* Trash Flowers: the desktop menus (Shop, Collabs) open as soon as the mouse rolls over them and close shortly after it
   leaves, so the short trip from the menu name down into the panel doesn't close it. A mouse click on an open menu
   leaves it open. Taps and the keyboard work as before (Dawn's click to open). */
(() => {
  const OPEN_DELAY = 60;
  const CLOSE_DELAY = 250;
  const menus = Array.from(document.querySelectorAll('.header__inline-menu header-menu'));

  menus.forEach((menu) => {
    const details = menu.querySelector('details');
    const summary = details && details.querySelector('summary');
    if (!summary) return;

    let openTimer;
    let closeTimer;

    const open = () => {
      menus.forEach((other) => {
        if (other !== menu && typeof other.close === 'function') other.close();
      });
      if (!details.open) details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', true);
    };

    const close = () => {
      if (typeof menu.close === 'function') menu.close();
    };

    details.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(open, OPEN_DELAY);
    });

    details.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(close, CLOSE_DELAY);
    });

    // A real mouse click (not Enter on the keyboard) on a menu the mouse already opened keeps it open.
    let lastPointer = '';
    summary.addEventListener('pointerdown', (event) => {
      lastPointer = event.pointerType;
    });
    summary.addEventListener('click', (event) => {
      if (event.detail === 0 || lastPointer !== 'mouse' || !details.open) return;
      event.preventDefault();
      summary.setAttribute('aria-expanded', true);
    });
  });
})();
